import React  from "react";
import { SuspenseWithPerf } from "reactfire";
import { useParams, useLocation } from "react-router-dom";
import TicketDetails from "./TicketDetails";
import Container from "@material-ui/core/Container";
import PageSubHeading from "../../components/PageSubHeading";
import Skeleton from "@material-ui/lab/Skeleton";
import AppHeader from "../../components/AppHeader";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Emoji from "a11y-react-emoji";
import PageHeading from "../../components/PageHeading";
import Helmet from "react-helmet";
import TicketCancellation from "./TicketCancellation";
import TicketReservationLocation from "../TicketReservation/TicketReservationLocation";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      backgroundColor: theme.palette.background.paper,
    },
  })
);

function Ticket() {
  const { gameId } = useParams();
  const query = useQuery();
  const classes = useStyles();

  const isNewTicket = query.get("newTicket") === 'true';

  return (
    <div className={classes.wrapper}>
      <Helmet>
        <title>Ticket - SG Coesfeld 06</title>
      </Helmet>
      <AppHeader title="Dein Ticket" />
      <Container maxWidth="sm">
        {isNewTicket && (
          <PageHeading>
            Super, deine Tickets sind reserviert <Emoji symbol="🎉" />
          </PageHeading>
        )}
        <Box mb={2}>
          <Typography color="textSecondary">
            Zeige dieses Ticket einfach am Eingang auf deinem Smartphone vor.
          </Typography>
        </Box>
        <SuspenseWithPerf
          traceId="TicketDetails"
          fallback={<Skeleton variant="rect" width="100%" height={142} />}
        >
          <TicketDetails gameId={gameId} query={query} />
        </SuspenseWithPerf>
        <PageSubHeading primary="Austragungsort" />
        <TicketReservationLocation gameId={gameId} />
        <Box mt={2}>
          <TicketCancellation gameId={gameId} />
        </Box>
      </Container>
    </div>
  );
}

export default Ticket;
